// extracted by mini-css-extract-plugin
module.exports = {"handupCount":"handupCount___3BYuq","countWrapper":"countWrapper___3zr4w","img":"img___Las0V","text":"text___7cpzF","icon":"icon___1CSV9"};